<template>
  <v-card>
    <v-toolbar dark class="primary">
      <v-btn icon @click.native="close" dark>
        <v-icon>fa-times</v-icon>
      </v-btn>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field label="Nazwa" v-model="nazwa"
                                  :rules="[nazwa_rules.required, nazwa_rules.min_length]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="Domyślna długość wizyty" v-model.number="dlugoscWizyty"
                                  :rules="[dlugosc_wizyty_rules.numbers, dlugosc_wizyty_rules.min]"
                                  type="number"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Cena (zł)" v-model.number="cena" :rules="[cena_rules.numbers, cena_rules.min]"
                                  type="number" @input="handleInput"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    <v-checkbox v-model="aktywny" label="Czy aktywny?" :readonly="this.id == 0"></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-toolbar flat color="white">
                        <v-toolbar-title>Kategorie ICD9</v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-list>
                          <v-list-item v-for="(item,index) in kody" :key="index">
                            <v-list-item-content>
                              {{ item.icD9_Kod + ' - ' + item.icD9_Opis }}
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon small @click="removeIcd9(item.icD9_Kod)" title="Usuń kategorie">fa-trash-alt
                              </v-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="pickICD" class="ml-3">Dodaj</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-textarea v-model="uwagi" label="Uwagi"></v-textarea>
                </v-row>
              </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close" color="error">Zamknij</v-btn>
      <v-btn color="success" @click="save">Zapisz</v-btn>
    </v-card-actions>
    <ICD9PIcker v-if="showAddIcd9" :visible="showAddIcd9" @close="showAddIcd9 = false"
                @category_selected="categorySelected"></ICD9PIcker>
  </v-card>
</template>

<script>
import ICD9PIcker from "@/components/visits/ICD9PIcker";
import {zabiegiService} from "@/services";
import swal from "sweetalert";

export default {
  name: "PodtypEdit",
  components: {ICD9PIcker},
  props: ['id', 'rodzic'],
  data() {
    return {
      valid: true,
      nazwa: '',
      cena: 0,
      previousPrice: 0,
      aktywny: true,
      uwagi: '',
      dlugoscWizyty: 30,
      kody: [],
      title: 'Dodawanie podtypu zabiegu',
      nazwa_rules: {
        required: value => !!value || 'Nazwa jest wymagana',
        min_length: value => !(value && value.length < 3) || 'Nazwa musi posiadać minimum 3 znaki'
      },
      dlugosc_wizyty_rules: {
        numbers: value => !isNaN(value) || 'Długośc wizyty musi być liczbą całkowita',
        min: value => Number(value) > 0 || 'Długośc wizyty musi być większa od 0'
      },
      cena_rules: {
        numbers: value => !isNaN(value) || 'Cena musi być liczbą',
        min: value => Number(value) > 0 || 'Cena nie może być mniejsza od 0'
      },
      showAddIcd9: false,
    }
  },
  mounted() {

    if (this.id && this.id > 0) {
      zabiegiService.getZabiegDetails(this.id).then(result => {
        let details = result.data.result
        this.nazwa = details.nazwa
        this.cena = details.cena
        this.dlugoscWizyty = details.dlugoscWizyty
        this.uwagi = details.uwagi
        this.aktywny = details.aktywny
        this.kody = details.kody
        this.title = 'Edycja podtypu zabiegu: '+this.nazwa
      }).catch(() => {
        this.showError(true, 'Błąd pobrania podtypu zabiegu')
      })
    }
  },
  methods: {
    handleInput(e) {
      let stringValue = e
      let regex = /^\d*(\,\d{1,2})?$/
      if (!stringValue.match(regex) && this.cena !== '') {
        this.cena = this.previousPrice
      }
      this.previousPrice = this.cena
    },
    close() {
      this.$emit('close')
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.id == 0) {
          zabiegiService.insertPodtyp({
            zabieg: {
              nazwa: this.nazwa,
              cena: this.cena,
              aktywny: this.aktywny,
              uwagi: this.uwagi,
              dlugoscWizyty: this.dlugoscWizyty,
              kody: this.kody,
            },
            parentId: this.rodzic
          }).then(() => {
            this.$emit('saved')
          }).catch((e) => {

            if (
                e.response != null &&
                e.response.data != null &&
                e.response.data.error != null
            ) {
              this.showError(false,e.response.data.error.message)
            } else {
              this.showError(false, 'Błąd zapisu podtypu zabiegu')
            }

          })
        } else {
          zabiegiService.updateZabieg({
            id: this.id,
            nazwa: this.nazwa,
            cena: this.cena,
            aktywny: this.aktywny,
            uwagi: this.uwagi,
            dlugoscWizyty: this.dlugoscWizyty,
            kody: this.kody,
          }).then(() => {
            this.$emit('saved')
          }).catch(() => {
            this.showError(false, 'Błąd zapisu podtypu zabiegu')
          })
        }
      }
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    pickICD() {
      this.showAddIcd9 = true
    },
    categorySelected(cat) {
      this.showAddIcd9 = false

      let itm = this.kody.find(x => x.icD9_Kod == cat.kod)
      if (itm == null) {
        let newItem = {
          id: 0,
          icD9_Kod: cat.kod,
          icD9_Opis: cat.kod_opis
        };
        this.kody.push(newItem)
      }
    },
    removeIcd9(kod) {
      let filterOut = this.kody.filter(e => e.icD9_Kod !== kod)
      this.kody = filterOut
    }
  }
}
</script>

<style scoped>

</style>